import { Button } from '@components/Button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography
} from '@material-ui/core';
import React, { useState } from 'react';
import {
  ContainerFieldsLogin,
  ContainerFieldsUser,
  ContainerSwitch,
  SwitchAdm
} from './styles';
import { useAuth } from '@context/auth';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { loginType } from '../ModalCadastrarFuncionario';
import { Color } from '@material-ui/lab';
import { Eye, EyeSlash } from '@phosphor-icons/react';
import { ToastMessage } from '@components/ToastMessage';
import { SearchContratos } from '@components/SearchContratos';
import { z } from 'zod';
import { useMutation } from '@tanstack/react-query';
import { updateEmployee } from '@api/update-employee';
import { AppError } from '@utils/AppError';
import { queryClient } from '@base/lib/react-query';
import { toast } from 'sonner';

interface PropsModal {
  openModal: boolean;
  closeModal: (action: boolean) => void;
  data: CadastroFuncionarioFormData;
}

export const cadastroFuncionarioSchema = z.object({
  idLogin: z.string().optional(),

  nome: z.string().min(5, { message: 'Esse campo é obrigatório' }),
  cpf: z.string().optional()
    .or(z.literal(''))
    .refine((val) => !val || val.length === 11, {
      message: 'CPF deve ter 11 dígitos',
    }),
  rg: z.string().optional(),
  administrador: z.boolean().default(false),
  tipo_login: z.enum(['administrativo', 'agendamento', 'financeiro']),
  usuario: z.string()
});

export type CadastroFuncionarioFormData = z.infer<
  typeof cadastroFuncionarioSchema
>;

export function ModalEditarFuncionario({
  openModal,
  closeModal,
  data
}: PropsModal) {
  const { user } = useAuth();
  const hora = new Date();
  const newHora = hora.toLocaleString('pt-BR', { hour12: false });
  const userUpdate = `${user.nome} ${newHora}`;

  const [showPassword, setShowPassword] = useState(false);
  const [toastMessage, setToastMessage] = useState({
    cod: '',
    message: '',
    color: '' as Color,
    show: false
  });

  const {
    register,
    handleSubmit,
    reset,
    control,
    getValues,
    formState: { errors, isSubmitting }
  } = useForm<CadastroFuncionarioFormData>({
    resolver: zodResolver(cadastroFuncionarioSchema),
    values: data,
    defaultValues: {
      usuario: userUpdate
    }
  });

  const { mutateAsync: update } = useMutation({
    mutationFn: updateEmployee
  });

  async function handleUpdateFuncionario(data: CadastroFuncionarioFormData) {
    console.log("📥 Dados recebidos no submit:", data);
    try {
      await update({
        idLogin: data.idLogin!,
        nome: data.nome,
        cpf: data.cpf!,
        administrador: data.administrador,
        login_usuario: '',
        senha_usuario: '',
        tipo_login: data.tipo_login,
        rg: data.rg,
        usuario: userUpdate,
        cod_contrato: ''
      });
          // Atualiza os dados em cache
      queryClient.invalidateQueries({ queryKey: ["getUserAdm"] });
      closeModal(false);
      toast.success('Atualizado com sucesso.');
      reset()

    } catch (error) {
      if (error instanceof AppError) {
        setToastMessage({
          cod: String(error.code),
          color: "error",
          message: error.message,
          show: true,
        });
      }
    }
  }

  function handleCloseModal() {
    closeModal(false);
    reset();
  }
 function updateCache() {
    queryClient.refetchQueries();
  }
  // function handleClickShowPassword() {
  // //   setShowPassword(!showPassword);
  // // }
  console.log(errors);
  //console.log(data);
  return (
    <Dialog open={openModal} onClose={closeModal} fullWidth>
      <form onSubmit={handleSubmit(handleUpdateFuncionario)}>
        <DialogTitle>Editar funcionário</DialogTitle>
        <DialogContent>
          <ContainerSwitch>
            <Grid container alignItems="center" justifyContent="flex-end">
              <Grid item>Normal</Grid>
              <Controller
                name="administrador"
                control={control}
                defaultValue={data.administrador}
                render={({ field: { name, onChange, value } }) => {
                  return (
                    <SwitchAdm
                      name={name}
                      defaultChecked={value}
                      checked={value}
                      onChange={(e) => {
                        onChange(e.target.checked);
                      }}
                    />
                  );
                }}
              />
              <Grid item>ADM</Grid>
            </Grid>
          </ContainerSwitch>
          <Typography variant="h5" style={{ margin: 10, fontWeight: 'bold' }}>
            Dados do usuário
          </Typography>
          <ContainerFieldsUser>
            <TextField
              label="Nome completo"
              variant="outlined"
              error={!!errors.nome?.message}
              helperText={errors.nome?.message}
              {...register('nome')}
            />
            <TextField
              label="CPF"
              variant="outlined"
              error={!!errors.cpf?.message}
              helperText={errors.cpf?.message}
              {...register('cpf')}
            />
            <TextField label="RG" variant="outlined" {...register('rg')} />
          </ContainerFieldsUser>
          <Typography variant="h5" style={{ margin: 10, fontWeight: 'bold' }}>
            Dados do login
          </Typography>
          <ContainerFieldsLogin>
             {/*<TextField
              label="E-mail"
              variant="outlined"
              error={!!errors.login_usuario?.message}
              helperText={errors.login_usuario?.message}
              {...register('login_usuario')}
            />
           <FormControl variant="outlined">
               <InputLabel htmlFor="outlined-adornment-password">
                Nova senha
              </InputLabel>
              <OutlinedInput
                label="nova senha"
                type={showPassword ? 'text' : 'password'}
                id="outlined-adornment-password"
                error={!!errors.senha_usuario?.message}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <Eye /> : <EyeSlash />}
                    </IconButton>
                  </InputAdornment>
                }
                {...register('senha_usuario')}
              />
            </FormControl> */}
            <FormControl variant="outlined">
              <InputLabel>Tipo do login</InputLabel>
              <Select
                error={!!errors.tipo_login?.message}
                label="Tipo do login"
                defaultValue={'agendamento'}
                {...register('tipo_login')}
              >
                {loginType.map((type) => {
                  return (
                    <MenuItem value={type.value} key={type.id}>
                      {type.tipo}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </ContainerFieldsLogin>
        </DialogContent>
        <DialogActions>
          <Button
            title="Cancelar"
            variantstyle="DEFAULT"
            onClick={handleCloseModal}
            type="button"
          />
          <Button
            type="submit"
            title="Salvar"
            variantstyle="SECUNDARY"
            isLoading={isSubmitting}
          />
        </DialogActions>
      </form>
      <ToastMessage
        code={toastMessage.cod}
        message={toastMessage.message}
        show={toastMessage.show}
        severity={toastMessage.color}
        onClose={() => {
          setToastMessage({
            cod: toastMessage.cod,
            color: toastMessage.color,
            message: toastMessage.message,
            show: false
          });
        }}
      />
    </Dialog>
  );
}